import { VueConstructor } from 'vue';

interface DraggableMoveContext<T> {
	element: T;
	index: number;
	list: T[];
	component: VueConstructor;
}

interface DraggableMoveRequest<T> {
	from: HTMLElement;
	to: HTMLElement;
	relatedContext: DraggableMoveContext<T>;
	draggedContext: DraggableMoveContext<T>;
}

/**
 * A helper for draggable elements that only allows movement to another draggable drop
 * zone, and not within in the original host area
 */
export function moveExternal(ctx: DraggableMoveRequest<unknown>): boolean {
	return ctx.from !== ctx.to;
}

/**
 * A helper for draggable elements that allows movement only within the original host
 * area, and not to any outside drop zones
 */
export function moveInternal(ctx: DraggableMoveRequest<unknown>): boolean {
	return ctx.from === ctx.to;
}
